import {
    MultiUserToken,
    LabelToken,
    ImpactToken,
    MultiLabelToken,
    DateTimeToken,
    CVEToken,
} from './tokens';
import { ApckGlFilteredSearchToken } from '../../components/filtered_search/apck_glfiltered_search_token';
import {CWE_STATUSES} from './utils';

export const FEED_STATUS_OPTIONS = [
    { id: 1, label: 'Active', value: 'active' },
    { id: 2, label: 'Inactive', value: 'inactive' },
    { id: 3, label: 'Error', value: 'error' },
];

const PROBABILITY_IMPACT_OPTIONS = [
    {
        icon: 'severity-critical',
        id: 7,
        title: 'Critical',
        value: '5.0-critical',
        name: '5.0-critical',
        color: '#c0392b',
        text_color: '#ffffff',
    },
    {
        icon: 'severity-high',
        id: 6,
        title: 'High',
        value: '4.0-high',
        name: '4.0-high',
        color: '#eb4e10',
        text_color: '#ffffff',
    },
    {
        icon: 'severity-medium',
        id: 5,
        title: 'Medium',
        value: '3.0-medium',
        name: '3.0-medium',
        color: '#f39c12',
        text_color: '#333333',
    },
    {
        icon: 'severity-low',
        id: 4,
        title: 'Low',
        value: '2.0-low',
        name: '2.0-low',
        color: '#27ae60',
        text_color: '#ffffff',
    },
    {
        icon: 'severity-info',
        id: 3,
        title: 'Info',
        value: '1.0-info',
        name: '1.0-info',
        color: '#1890ff',
        text_color: '#ffffff',
    },
    {
        icon: 'issue-type-test-case',
        id: 2,
        title: 'Investigate',
        value: '0.0-investigate',
        name: '0.0-investigate',
        color: '#8ecae6',
        text_color: '#ffffff',
    },
    {
        icon: 'severity-unknown',
        id: 1,
        title: 'Unknown',
        value: '0.0-unknown',
        name: '0.0-unknown',
        color: '#8ecae6',
        text_color: '#ffffff',
    },
    {
        icon: 'status-failed',
        id: 0,
        title: 'NULL',
        value: 'null',
        name: null,
        color: '#123456',
        text_color: '#ffffff',
    },
];
const CUSTOMER_PROBABILITY_IMPACT_OPTIONS = PROBABILITY_IMPACT_OPTIONS.slice(0, -1);
const STATUS_OPTIONS = [
    {
        icon: 'severity-low',
        id: 3,
        title: 'Allowed',
        value: CWE_STATUSES.ALLOWED,
        name: 'allowed',
        color: '#28a745',
        text_color: '#ffffff', 
    },
    {
        icon: 'severity-medium',
        id: 2,
        title: 'Discouraged',
        value: CWE_STATUSES.DISCOURAGED,
        name: 'discouraged',
        color: '#5CB85C',
        text_color: '#ffffff',
    },
    {
        icon: 'severity-critical',
        id: 1,
        title: 'Prohibited',
        value: CWE_STATUSES.PROHIBITED,
        name: 'prohibited',
        color: '#dede9e',
        text_color: '#333333',
    },
];

const BOOLEAN_OPTIONS = [
    {
        icon: 'merge-request-close-m',
        id: 1,
        title: 'False',
        value: false,
        name: 'false',
        color: '#123456',
        text_color: '#ffffff',
    },
    {
        icon: 'check',
        id: 2,
        title: 'True',
        value: true,
        name: 'true',
        color: '#d90429',
        text_color: '#ffffff',
    },
];

const BOOLEAN_OPTIONS_NULL = [
    ...BOOLEAN_OPTIONS,
    {
        icon: 'status_notfound',
        id: 3,
        title: 'None',
        value: 'null',
        name: null,
        color: '#6c757d',
        text_color: '#ffffff',
    },
];

const SECURITY_OPTIONS = [
    {
        icon: 'lock',
        id: 1,
        title: 'recommended',
        value: 'recommended',
        name: 'recommended',
        color: '#198754',
        text_color: '#ffffff',
    },
    {
        icon: 'lock',
        id: 2,
        title: 'secure',
        value: 'secure',
        name: 'secure',
        color: '#0d6efd',
        text_color: '#ffffff',
    },
    {
        icon: 'lock-open',
        id: 3,
        title: 'weak',
        value: 'weak',
        name: 'weak',
        color: '#ffc107',
        text_color: '#ffffff',
    },
    {
        icon: 'lock-open',
        id: 4,
        title: 'insecure',
        value: 'insecure',
        name: 'insecure',
        color: '#dc3545!important',
        text_color: '#ffffff',
    },
];

const SEVERITY_OPTIONS = [
    {
        icon: 'warning',
        id: 1,
        title: 'warning',
        value: 'warning',
        name: 'warning',
        color: '#ffc107',
        text_color: '#ffffff',
    },
    {
        icon: 'warning-solid',
        id: 2,
        title: 'danger',
        value: 'danger',
        name: 'danger',
        color: '#dc3545!important',
        text_color: '#ffffff',
    },
];

export function VulnerabilityTokenList(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'token-id-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'token-1',
            type: 'created_by',
            icon: 'pencil',
            title: 'Created By',
            dataType: 'user',
            unique: true,
            token: MultiUserToken,
            url: `${url}/users/`,
            requestOptsFunc,
            traditional: true,
            paramGetter: (obj) => ({ search: obj.value.data, page_size: 30 }),
            operators: [
                // { value: '=', description: 'is', default: 'true' },
                // { value: '!=', description: 'is not one of' },
                { value: '~=', description: 'is one of' },
                { value: '!~=', description: 'is not one of' },
            ],
            multiSelect: true,
        },
        {
            id: 'token-2',
            type: 'changed_by',
            icon: 'pencil',
            title: 'Changed By',
            dataType: 'changed_by',
            unique: true,
            token: MultiUserToken,
            url: `${url}/users/`,
            requestOptsFunc,
            traditional: true,
            paramGetter: (obj) => ({ search: obj.value.data, all: true }),
            operators: [
                { value: '~=', description: 'is one of' },
                { value: '!~=', description: 'is not one of' },
            ],
            multiSelect: true,
        },
        {
            id: 'token-3',
            type: 'impact',
            icon: 'scale',
            title: 'Impact',
            token: ImpactToken,
            options: PROBABILITY_IMPACT_OPTIONS,
        },
        {
            id: 'token-4',
            type: 'probability',
            icon: 'tachometer',
            title: 'Probability',
            token: ImpactToken,
            options: PROBABILITY_IMPACT_OPTIONS,
        },
        {
            id: 'token-5',
            type: 'feed_name',
            icon: 'trigger-source',
            title: 'Feed Name',
            token: LabelToken,
            displayKey: 'name',
            key: 'name',
            url: `${url}/feeds/`,
            requestOptsFunc,
            paramGetter: (obj) => ({ all: true, search: String(obj.value.data) }),
            cacheResults: true,
        },
        {
            id: 'token-6',
            type: 'category',
            icon: 'folder-o',
            title: 'Category',
            token: LabelToken,
            displayKey: 'name',
            key: 'name',
            url: `${url}/vulns/category/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e.name, value: e.value }),
            cacheResults: true,
        },
        {
            id: 'token-7',
            type: 'type',
            icon: 'issue-type-feature-flag',
            title: 'Type',
            token: LabelToken,
            displayKey: 'name',
            key: 'name',
            url: `${url}/vulns/type/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e }),
            cacheResults: true,
        },
        {
            id: 'token-8',
            type: 'product',
            icon: 'bulb',
            title: 'Product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'token-9',
            type: 'version',
            icon: 'bookmark',
            title: 'Version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'token-10',
            type: 'vendor',
            icon: 'package',
            title: 'Vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'token-11',
            type: 'title',
            icon: 'title',
            title: 'Title',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉S', description: 'does not contain (case sensitive)' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-12',
            type: 'cvss_v3_note',
            icon: 'keyboard',
            title: 'CVSS V3 Note',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-13',
            type: 'created_on',
            icon: 'calendar',
            title: 'Created On',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: true,
                    allowEmpty: false,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'datetime-local',
            token: DateTimeToken,
        },
        {
            id: 'token-14',
            type: 'changed_on',
            icon: 'calendar',
            title: 'Changed On',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: true,
                    allowEmpty: false,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'datetime-local',
            token: DateTimeToken,
        },
        {
            id: 'token-15',
            type: 'cvss_v2_note',
            icon: 'keyboard',
            title: 'CVSS V2 Note',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-34',
            type: 'cvss_v4_vector',
            icon: 'minimize',
            title: 'CVSS V4 Vector',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-16',
            type: 'cvss_v3_vector',
            icon: 'minimize',
            title: 'CVSS V3 Vector',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-17',
            type: 'cvss_v2_vector',
            icon: 'minimize',
            title: 'CVSS V2 Vector',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-18',
            type: 'cvss_v3_score',
            icon: 'star-o',
            title: 'CVSS V3 Score',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-19',
            type: 'cvss_v2_score',
            icon: 'star-o',
            title: 'CVSS V2 Score',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-20',
            type: 'remediation',
            icon: 'title',
            title: 'Remediation',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-21',
            type: 'details',
            icon: 'details-block',
            title: 'Details',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-22',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-23',
            type: 'references',
            icon: 'title',
            title: 'References',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-24',
            type: 'owasp_2013',
            icon: 'quota',
            title: 'OWASP 2013',
            token: LabelToken,
            displayKey: 'name',
            key: 'value',
            url: `${url}/vulns/owasp_2013/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e.name, value: e.value }),
            cacheResults: true,
        },
        {
            id: 'token-25',
            type: 'owasp_2017',
            icon: 'quota',
            title: 'OWASP 2017',
            token: LabelToken,
            displayKey: 'name',
            key: 'value',
            url: `${url}/vulns/owasp_2017/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e.name, value: e.value }),
            cacheResults: true,
        },
        {
            id: 'token-26',
            type: 'owasp_2021',
            icon: 'quota',
            title: 'OWASP 2021',
            token: LabelToken,
            displayKey: 'name',
            key: 'value',
            url: `${url}/vulns/owasp_2021/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e.name, value: e.value }),
            cacheResults: true,
        },
        // make this into a simple Filter-Search token instead of the
        // label one.
        // Ref: https://dev.appcheck-ng.com/appcheck-ng/apck-vuln-feed/-/issues/343
        {
            id: 'token-27',
            type: 'workflow_quality',
            icon: 'chart',
            title: 'Workflow Quality',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        // {
        //     id: 'token-27',
        //     type: 'workflow_quality',
        //     icon: 'chart',
        //     title: 'Workflow Quality',
        //     token: LabelToken,
        //     key: 'name',
        //     displayKey: 'name',
        //     url: `${url}/vulns/workflow_quality/search/`,
        //     requestOptsFunc,
        //     paramGetter: (obj) => ({ search: obj.value.data }),
        //     processData: (e, idx) => ({ id: idx, name: e }),
        //     cacheResults: true,
        // },
        {
            id: 'token-28',
            type: 'workflow_status',
            icon: 'status',
            title: 'Workflow Status',
            token: LabelToken,
            key: 'name',
            displayKey: 'name',
            url: `${url}/vulns/workflow_status/search/`,
            requestOptsFunc,
            paramGetter: (obj) => ({ search: obj.value.data }),
            processData: (e, idx) => ({ id: idx, name: e }),
            cacheResults: true,
        },
        {
            id: 'token-29',
            type: 'workflow_priority',
            icon: 'clock',
            title: 'Workflow Priority',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-30',
            type: 'cwes',
            icon: 'dot-grid',
            title: 'CWE',
            multiSelect: true,
            displayKey: 'cwe',
            key: 'db_id',
            url: `${url}/cwes/`,
            requestOptsFunc,
            paramGetter: (obj, forSelect) => {
                if (forSelect) {
                    return {};
                }
                return { search: String(obj.value.data), fields: ['cwe', 'id', 'name'] };
            },
            traditional: true,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~=', description: 'is one of' },
                { value: '!~=', description: 'is not one of' },
            ],
            token: MultiLabelToken,
        },
        {
            id: 'token-31',
            type: 'cves',
            icon: 'bug',
            title: 'CVE',
            multiSelect: true,
            displayKey: 'cve',
            key: 'db_id',
            url: `${url}/cves/`,
            paramGetter: (obj, forSelect) => {
                if (forSelect) {
                    return {};
                }
                return { search: String(obj.value.data) };
            },
            traditional: true,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~=', description: 'is one of' },
                { value: '!~=', description: 'is not one of' },
            ],
            token: MultiLabelToken,
        },
        {
            id: 'token-32',
            type: 'patches',
            icon: 'archive',
            title: 'Patches',
            url: `${url}/patch/list/`,
            multiSelect: true,
            key: 'id',
            displayKey: 'title',
            paramGetter: (obj) => ({
                search: String(obj.value.data),
                page_size: 200,
                fields: ['title', 'id'],
            }),
            traditional: true,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~=', description: 'is one of' },
                { value: '!~=', description: 'is not one of' },
            ],
            token: MultiLabelToken,
        },
        {
            id: 'token-34',
            type: 'forked',
            icon: 'branch',
            title: 'Forked',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
            ],
        },
        {
            id: 'token-35',
            type: 'affected.id',
            icon: 'bug',
            title: '# of Affected',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'is greater than' },
                { value: '<', description: 'is smaller than' },
                { value: '>=', description: 'is greater than or equal to' },
                { value: '<=', description: 'is smaller than or equal to' },
            ],
        },
        {
            id: 'token-36',
            type: 'fixed.id',
            icon: 'canceled-circle',
            title: '# of Fixed',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'is greater than' },
                { value: '<', description: 'is smaller than' },
                { value: '>=', description: 'is greater than or equal to' },
                { value: '<=', description: 'is smaller than or equal to' },
            ],
        },
        {
            id: 'token-37',
            type: 'affected.cpe.product',
            icon: 'bulb',
            title: 'Affected Product',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'token-38',
            type: 'fixed.cpe.product',
            icon: 'bulb',
            title: 'Fixed Product',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'token-39',
            type: 'affected.cpe.vendor',
            icon: 'package',
            title: 'Affected Vendor',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'token-40',
            type: 'fixed.cpe.vendor',
            icon: 'package',
            title: 'Fixed Vendor',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'token-41',
            type: 'affected.cpe.version',
            icon: 'bookmark',
            title: 'Affected Version',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'token-42',
            type: 'fixed.cpe.version',
            icon: 'bookmark',
            title: 'Fixed Version',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'token-43',
            type: 'internal_notes',
            icon: 'doc-text',
            title: 'Internal Notes',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-43',
            type: 'target_workflow_quality',
            icon: 'work',
            title: 'Target Workflow Quality',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'token-44',
            type: 'quality_review',
            icon: 'review-checkmark',
            title: 'Quality Review',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'check-circle-filled', value: 'true', title: 'Met' },
                { icon: 'clear', value: 'false', title: 'Not Met' },
            ],
        },
        {
            id: 'token-45',
            type: 'vuln_source_id',
            icon: 'symlink',
            title: 'CNA',
            multiSelect: true,
            displayKey: 'name',
            key: 'db_id',
            url: `${url}/vs/list/`,
            paramGetter: (obj, forSelect) => {
                if (forSelect) {
                    return {};
                }
                return { search: String(obj.value.data) };
            },
            traditional: true,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~=', description: 'is one of' },
                { value: '!~=', description: 'is not one of' },
            ],
            token: MultiLabelToken,
        },
        {
            id: 'token-46',
            type: 'cwes.id',
            icon: 'dot-grid',
            title: '# of CWEs',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'is greater than' },
                { value: '<', description: 'is smaller than' },
                { value: '>=', description: 'is greater than or equal to' },
                { value: '<=', description: 'is smaller than or equal to' },
            ],
        },
        {
            id: 'token-47',
            type: 'suggestions',
            icon: 'bulb',
            title: 'Suggestions',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'eye-slash', value: 'true', title: 'Yes' },
                { icon: 'eye', value: 'false', title: 'No' },
            ],
        },
        {
            id: 'token-48',
            type: 'title_suggestions',
            icon: 'bulb',
            title: 'Title Suggestions',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
            ],
        },
        {
            id: 'token-49',
            type: 'euvds',
            icon: 'bug',
            title: 'EUVD',
            multiSelect: true,
            displayKey: 'euvd',
            key: 'db_id',
            url: `${url}/euvds/`,
            paramGetter: (obj, forSelect) => {
                if (forSelect) {
                    return {};
                }
                return { search: String(obj.value.data) };
            },
            traditional: true,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~=', description: 'is one of' },
                { value: '!~=', description: 'is not one of' },
            ],
            token: MultiLabelToken,
        },
        {
            id: 'token-50',
            type: 'is_reviewed',
            icon: 'review-checkmark',
            title: 'Reviewed',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'eye-slash', value: 'true', title: 'Yes' },
                { icon: 'eye', value: 'false', title: 'No' },
            ],
        },
        {
            id: 'token-51',
            type: 'aliases.reference',
            icon: 'api',
            title: 'Alias',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-52',
            type: 'is_junk',
            icon: 'bitbucket',
            title: 'Junk?',
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'eye-slash', value: 'true', title: 'Yes' },
                { icon: 'eye', value: 'false', title: 'No' },
            ],
        },
        {
            id: 'token-53',
            type: 'pending_cpes',
            icon: 'status_pending',
            title: 'Pending CPEs',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
            {
                icon: 'status_notfound',
                id: 3,
                title: 'None',
                value: 'null',
                name: null,
                color: '#6c757d',
                text_color: '#ffffff',
            },
            ],
        },
        {
            id: 'token-54',
            type: 'affected_packages.id',
            icon: 'package',
            title: 'PURLs',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
            {
                icon: 'status_notfound',
                id: 3,
                title: 'None',
                value: 'null',
                name: null,
                color: '#6c757d',
                text_color: '#ffffff',
            },
            ],
        },
    ];
    return tokens.sort((a, b) => (a.title > b.title ? 1 : -1));
}

export function AssocPatchCPEListTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'apc-1',
            type: 'id',
            icon: 'commit',
            title: 'Assoc ID',
            dataType: 'assoc_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'apc-2',
            type: 'cpe.id',
            icon: 'commit',
            title: 'CPE ID',
            dataType: 'cpe_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'apc-3',
            type: 'severity',
            icon: 'severity-unknown',
            title: 'Severity',
            dataType: 'severity',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'apc-5',
            type: 'cpe.product',
            icon: 'bulb',
            title: 'Product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-6',
            type: 'cpe.version',
            icon: 'bookmark',
            title: 'Version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-7',
            type: 'cpe.vendor',
            icon: 'package',
            title: 'Vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-token-8',
            type: 'patch_id',
            icon: 'details-block',
            title: 'Patch ID',
            dataType: 'patch_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
    ];
    return tokens;
}

export function AssocRawPatchCPEListTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'apc-1',
            type: 'id',
            icon: 'commit',
            title: 'Assoc ID',
            dataType: 'assoc_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'apc-2',
            type: 'cpe.id',
            icon: 'commit',
            title: 'CPE ID',
            dataType: 'cpe_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'apc-3',
            type: 'severity',
            icon: 'severity-unknown',
            title: 'Severity',
            dataType: 'severity',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'apc-5',
            type: 'cpe.product',
            icon: 'bulb',
            title: 'Product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-6',
            type: 'cpe.version',
            icon: 'bookmark',
            title: 'Version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-7',
            type: 'cpe.vendor',
            icon: 'package',
            title: 'Vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-token-8',
            type: 'raw_patch_id',
            icon: 'details-block',
            title: 'Raw Patch ID',
            dataType: 'raw_patch_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
    ];
    return tokens;
}

export function AssocOrgPatchCPEListTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'apc-1',
            type: 'id',
            icon: 'commit',
            title: 'Assoc ID',
            dataType: 'assoc_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'apc-2',
            type: 'cpe.id',
            icon: 'commit',
            title: 'CPE ID',
            dataType: 'cpe_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'apc-3',
            type: 'severity',
            icon: 'severity-unknown',
            title: 'Severity',
            dataType: 'severity',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'apc-5',
            type: 'cpe.product',
            icon: 'bulb',
            title: 'Product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-6',
            type: 'cpe.version',
            icon: 'bookmark',
            title: 'Version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-7',
            type: 'cpe.vendor',
            icon: 'package',
            title: 'Vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'apc-token-8',
            type: 'org_patch_id',
            icon: 'details-block',
            title: 'Org Patch ID',
            dataType: 'org_patch_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
    ];
    return tokens;
}

export function AssocAffectedTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'aa-token-1',
            type: 'id',
            icon: 'commit',
            title: 'Assoc ID',
            dataType: 'assoc_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'aa-token-2',
            type: 'cpe.id',
            icon: 'commit',
            title: 'CPE ID',
            dataType: 'cpe_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'aa-token-3',
            type: 'first',
            icon: 'first-contribution',
            title: 'First',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
        {
            id: 'aa-token-4',
            type: 'last',
            icon: 'sort-lowest',
            title: 'Last',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
        {
            id: 'aa-token-5',
            type: 'cpe.product',
            icon: 'bulb',
            title: 'Product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aa-token-6',
            type: 'cpe.version',
            icon: 'bookmark',
            title: 'Version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aa-token-7',
            type: 'cpe.vendor',
            icon: 'package',
            title: 'Vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aa-token-8',
            type: 'cpe.update',
            icon: 'container-image',
            title: 'Update',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aa-token-9',
            type: 'cpe.language',
            icon: 'earth',
            title: 'Language',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aa-token-10',
            type: 'cpe.sw_edition',
            icon: 'applications',
            title: 'SW Edition',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aa-token-1011',
            type: 'cpe.source_type',
            icon: 'formula',
            title: 'Source Type (Fabricated)',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'check-sm', value: 'Official', title: 'Official' },
                { icon: 'settings', value: 'Feed Fabricated', title: 'Feed Fabricated' },
                { icon: 'user', value: 'User Fabricated', title: 'User Fabricated' },
            ],
        },
    ];
    return tokens;
}

export function AssocFixedTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'af-token-1',
            type: 'id',
            icon: 'commit',
            title: 'Assoc ID',
            dataType: 'assoc_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'af-token-2',
            type: 'cpe.id',
            icon: 'commit',
            title: 'CPE ID',
            dataType: 'cpe_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'af-token-3',
            type: 'recommended',
            icon: 'podcast',
            title: 'Recommended',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
        {
            id: 'af-token-4',
            type: 'cpe.product',
            icon: 'bulb',
            title: 'Product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'af-token-5',
            type: 'cpe.version',
            icon: 'bookmark',
            title: 'Version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'af-token-6',
            type: 'cpe.vendor',
            icon: 'package',
            title: 'Vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'af-token-7',
            type: 'cpe.update',
            icon: 'container-image',
            title: 'Update',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'af-token-8',
            type: 'cpe.language',
            icon: 'earth',
            title: 'Language',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'af-token-9',
            type: 'cpe.sw_edition',
            icon: 'applications',
            title: 'SW Edition',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'af-token-10',
            type: 'cpe.source_type',
            icon: 'formula',
            title: 'Source Type (Fabricated)',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'check-sm', value: 'Official', title: 'Official' },
                { icon: 'settings', value: 'Feed Fabricated', title: 'Feed Fabricated' },
                { icon: 'user', value: 'User Fabricated', title: 'User Fabricated' },
            ],
        },
    ];
    return tokens;
}

export function CPETokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'cpe-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-token-2',
            type: 'title',
            icon: 'title',
            title: 'Title',
            dataType: 'title',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-2',
            type: 'part',
            icon: 'comment-dots',
            title: 'Part',
            dataType: 'part',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-3',
            type: 'vendor',
            icon: 'building',
            title: 'Vendor',
            dataType: 'vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-4',
            type: 'product',
            icon: 'cherry-pick-commit',
            title: 'Product',
            dataType: 'product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-5',
            type: 'version',
            icon: 'doc-versions',
            title: 'Version',
            dataType: 'version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-6',
            type: 'update',
            icon: 'container-image',
            title: 'Update',
            dataType: 'update',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-7',
            type: 'edition',
            icon: 'applications',
            title: 'Edition',
            dataType: 'edition',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-8',
            type: 'language',
            icon: 'earth',
            title: 'Language',
            dataType: 'language',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-9',
            type: 'sw_target',
            icon: 'monitor-o',
            title: 'Target SW',
            dataType: 'sw_target',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-10',
            type: 'hw_target',
            icon: 'mobile',
            title: 'Target HW',
            dataType: 'hw_target',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-11',
            type: 'other',
            icon: 'dash',
            title: 'Other',
            dataType: 'other',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-2',
            type: 'original_part',
            icon: 'comment-dots',
            title: 'Original Part',
            dataType: 'part',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-3',
            type: 'original_vendor',
            icon: 'building',
            title: 'Original Vendor ',
            dataType: 'vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-4',
            type: 'original_product',
            icon: 'cherry-pick-commit',
            title: 'Original Product',
            dataType: 'product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-5',
            type: 'original_version',
            icon: 'doc-versions',
            title: 'Original Version',
            dataType: 'version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-6',
            type: 'original_update',
            icon: 'container-image',
            title: 'Original Update',
            dataType: 'update',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-7',
            type: 'original_edition',
            icon: 'applications',
            title: 'Original Edition',
            dataType: 'edition',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-8',
            type: 'original_language',
            icon: 'earth',
            title: 'Original Language',
            dataType: 'language',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-9',
            type: 'original_sw_target',
            icon: 'monitor-o',
            title: 'Original Target SW',
            dataType: 'sw_target',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-10',
            type: 'original_hw_target',
            icon: 'mobile',
            title: 'Original Target HW',
            dataType: 'hw_target',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-canonical-token-11',
            type: 'original_other',
            icon: 'dash',
            title: 'Original Other',
            dataType: 'other',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-token-12',
            type: 'deprecated',
            icon: 'mobile',
            title: 'Deprecated',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'eye-slash', value: 'true', title: 'Yes' },
                { icon: 'eye', value: 'false', title: 'No' },
            ],
        },
        {
            id: 'cpe-token-13',
            type: 'source_type',
            icon: 'formula',
            title: 'Source Type (Fabricated)',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'check-sm', value: 'Official', title: 'Official' },
                { icon: 'settings', value: 'Feed Fabricated', title: 'Feed Fabricated' },
                { icon: 'user', value: 'User Fabricated', title: 'User Fabricated' },
            ],
        },
        {
            id: 'cpe-token-14',
            type: 'sortable_ver',
            icon: 'sort-highest',
            title: 'Sortable Ver',
            dataType: 'sortable_ver',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function CPEAliasTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'cpe-alias-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-alias-token-2',
            type: 'match_part',
            icon: 'comment-dots',
            title: 'Part',
            dataType: 'match_part',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-3',
            type: 'match_vendor',
            icon: 'building',
            title: 'Vendor',
            dataType: 'match_vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-4',
            type: 'match_product',
            icon: 'cherry-pick-commit',
            title: 'Product',
            dataType: 'match_product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-5',
            type: 'match_version',
            icon: 'doc-versions',
            title: 'Version',
            dataType: 'match_version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-6',
            type: 'match_update',
            icon: 'container-image',
            title: 'Update',
            dataType: 'match_update',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-7',
            type: 'match_edition',
            icon: 'applications',
            title: 'Edition',
            dataType: 'match_edition',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-8',
            type: 'match_language',
            icon: 'earth',
            title: 'Language',
            dataType: 'match_language',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-9',
            type: 'match_sw_target',
            icon: 'monitor-o',
            title: 'Target SW',
            dataType: 'match_sw_target',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-10',
            type: 'match_hw_target',
            icon: 'mobile',
            title: 'Target HW',
            dataType: 'match_hw_target',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-token-11',
            type: 'match_other',
            icon: 'dash',
            title: 'Other',
            dataType: 'match_other',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-2',
            type: 'override_part',
            icon: 'comment-dots',
            title: 'Override Part',
            dataType: 'override_part',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-3',
            type: 'override_vendor',
            icon: 'building',
            title: 'Override Vendor ',
            dataType: 'override_vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-4',
            type: 'override_product',
            icon: 'cherry-pick-commit',
            title: 'Override Product',
            dataType: 'override_product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-5',
            type: 'override_version',
            icon: 'doc-versions',
            title: 'Override Version',
            dataType: 'override_version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-6',
            type: 'override_update',
            icon: 'container-image',
            title: 'Override Update',
            dataType: 'override_update',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-7',
            type: 'override_edition',
            icon: 'applications',
            title: 'Override Edition',
            dataType: 'override_edition',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-8',
            type: 'override_language',
            icon: 'earth',
            title: 'Override Language',
            dataType: 'override_language',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-9',
            type: 'alias_sw_target',
            icon: 'monitor-o',
            title: 'Override Target SW',
            dataType: 'alias_sw_target',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-10',
            type: 'alias_hw_target',
            icon: 'mobile',
            title: 'Override Target HW',
            dataType: 'alias_hw_target',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-alias-canonical-token-11',
            type: 'override_other',
            icon: 'dash',
            title: 'Override Other',
            dataType: 'override_other',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function EUVDTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'euvd-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'euvd-token-2',
            type: 'euvd',
            icon: 'details-block',
            title: 'EUVD',
            dataType: 'euvd',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function CVETokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'cve-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cve-token-2',
            type: 'cve',
            icon: 'details-block',
            title: 'CVE',
            dataType: 'cve',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function CWETokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'cwe-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cwe-token-2',
            type: 'cwe',
            icon: 'details-block',
            title: 'CWE',
            dataType: 'cwe',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cwe-token-3',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            dataType: 'description',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cwe-token-4',
            type: 'name',
            icon: 'title',
            title: 'Name',
            dataType: 'name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cwe-token-5',
            type: 'short_name',
            icon: 'title',
            title: 'Short Name',
            dataType: 'short_name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cwe-token-6',
            type: 'assigned_category',
            icon: 'folder-o',
            title: 'Assigned Category',
            token: LabelToken,
            nullValue: '""',
            displayKey: 'name',
            key: 'name',
            url: `${url}/vulns/category/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e.name, value: e.value }),
            cacheResults: true,
        },
        {
            id: 'cwe-token-7',
            type: 'assigned_owasp_2013',
            icon: 'quota',
            title: 'Assigned OWASP 2013',
            token: LabelToken,
            displayKey: 'name',
            key: 'value',
            url: `${url}/vulns/owasp_2013/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e.name, value: e.value }),
            cacheResults: true,
        },
        {
            id: 'cwe-token-8',
            type: 'assigned_owasp_2017',
            icon: 'quota',
            title: 'Assigned OWASP 2017',
            token: LabelToken,
            displayKey: 'name',
            key: 'value',
            url: `${url}/vulns/owasp_2017/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e.name, value: e.value }),
            cacheResults: true,
        },
        {
            id: 'cwe-token-9',
            type: 'assigned_owasp_2021',
            icon: 'quota',
            title: 'Assigned OWASP 2021',
            token: LabelToken,
            displayKey: 'name',
            key: 'value',
            url: `${url}/vulns/owasp_2021/search/`,
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
            processData: (e, idx) => ({ id: idx, name: e.name, value: e.value }),
            cacheResults: true,
        },
        {
            id: 'cwe-token-10',
            type: 'status',
            icon: 'title',
            title: 'Status',
            dataType: 'status',
            showFriendlyText: true,
            token: ImpactToken,
            options: STATUS_OPTIONS,
        },
    ];
    return tokens;
}

export function VendorRefTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'vendor-ref-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'vendor-ref-token-2',
            type: 'reference',
            icon: 'title',
            title: 'Reference',
            dataType: 'reference',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'vendor-ref-token-3',
            type: 'source',
            icon: 'title',
            title: 'Source',
            dataType: 'source',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function PatchTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'patch-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'patch-token-2',
            type: 'patch_id',
            icon: 'details-block',
            title: 'Patch ID',
            dataType: 'patch_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '∈',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-3',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            dataType: 'description',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-4',
            type: 'title',
            icon: 'title',
            title: 'Title',
            dataType: 'title',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-5',
            type: 'release_date',
            icon: 'calendar',
            title: 'Release Date',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
    ];
    return tokens;
}

export function RawVulnTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'rawvuln-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'rawvuln-token-2',
            type: 'feed_name',
            icon: 'trigger-source',
            title: 'Feed Name',
            token: LabelToken,
            displayKey: 'name',
            key: 'name',
            url: `${url}/feeds/`,
            requestOptsFunc,
            paramGetter: (obj) => ({ all: true, search: String(obj.value.data) }),
            cacheResults: true,
        },
        {
            id: 'rawvuln-token-3',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            dataType: 'description',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'rawvuln-token-4',
            type: 'title',
            icon: 'title',
            title: 'Title',
            dataType: 'title',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'rawvuln-token-5',
            type: 'created_on',
            icon: 'calendar',
            title: 'Created On',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'datetime-local',
            token: DateTimeToken,
        },
        {
            id: 'rawvuln-token-5',
            type: 'changed_on',
            icon: 'calendar',
            title: 'Changed On',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'datetime-local',
            token: DateTimeToken,
        },
    ];
    return tokens;
}

export function VulnDetectionTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'vulndetection-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'vulndetection-token-2',
            type: 'plugin_id',
            icon: 'commit',
            title: 'Plugin ID',
            dataType: 'plugin_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'vulndetection-token-3',
            type: 'plugin_name',
            icon: 'text-description',
            title: 'Description',
            dataType: 'plugin_name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'vulndetection-token-4',
            type: 'scanner',
            icon: 'compass',
            title: 'Scanner',
            dataType: 'scanner',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'vulndetection-token-5',
            type: 'authenticated',
            icon: 'check-circle-dashed',
            title: 'Authenticated',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
        {
            id: 'vulndetection-token-6',
            type: 'unauthenticated',
            icon: 'canceled-circle',
            title: 'Unauthenticated',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
    ];
    return tokens;
}

export function AssocAffectedVulnListTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'aal-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'aal-token-2',
            type: 'cpe.id',
            icon: 'commit',
            title: 'CPE ID',
            dataType: 'cpe.id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'aal-token-3',
            type: 'first',
            icon: 'first-contribution',
            title: 'First',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
        {
            id: 'aal-token-4',
            type: 'last',
            icon: 'sort-lowest',
            title: 'Last',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
        {
            id: 'aal-token-5',
            type: 'cpe.product',
            icon: 'bulb',
            title: 'Product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aal-token-6',
            type: 'cpe.version',
            icon: 'bookmark',
            title: 'Version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aal-token-7',
            type: 'cpe.vendor',
            icon: 'package',
            title: 'Vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
    ];
    return tokens;
}

export function AssocFixedVulnListTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'aaf-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'aaf-token-2',
            type: 'cpe.id',
            icon: 'commit',
            title: 'CPE ID',
            dataType: 'cpe.id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'aaf-token-3',
            type: 'recommended',
            icon: 'podcast',
            title: 'Recommended',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
        {
            id: 'aaf-token-5',
            type: 'cpe.product',
            icon: 'bulb',
            title: 'Product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aaf-token-6',
            type: 'cpe.version',
            icon: 'bookmark',
            title: 'Version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
        {
            id: 'aaf-token-7',
            type: 'cpe.vendor',
            icon: 'package',
            title: 'Vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            paramGetter: (obj) => ({ search: obj.value.data }),
            requestOptsFunc,
        },
    ];
    return tokens;
}

export function FeedTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'feed-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'feed-token-2',
            type: 'status',
            icon: 'details-block',
            title: 'Status',
            dataType: 'status',
            token: ImpactToken,
            options: FEED_STATUS_OPTIONS,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
            ],
        },
        {
            id: 'feed-token-3',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            dataType: 'description',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'feed-token-4',
            type: 'name',
            icon: 'title',
            title: 'Name',
            dataType: 'name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'feed-token-5',
            type: 'last_successful_started',
            icon: 'calendar',
            title: 'Last Successful Started',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'feed-token-6',
            type: 'last_successful_finished',
            icon: 'calendar',
            title: 'Last Successful Finished',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'feed-token-7',
            type: 'last_started',
            icon: 'calendar',
            title: 'Last Started',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'feed-token-8',
            type: 'last_finished',
            icon: 'calendar',
            title: 'Last Finished',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'feed-token-9',
            type: 'created_on',
            icon: 'calendar',
            title: 'Created On',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'feed-token-10',
            type: 'Changed On',
            icon: 'calendar',
            title: 'Changed On',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'feed-token-11',
            type: 'Auto Approve',
            icon: 'first-contribution',
            title: 'Auto Approve',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
        {
            id: 'feed-token-12',
            type: 'force_full_import',
            icon: 'import',
            title: 'Force Full Import',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS,
        },
    ];
    return tokens;
}

export function KVSTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'kvs-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'db_id',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'kvs-token-2',
            type: 'vendor',
            icon: 'package',
            title: 'Vendor',
            dataType: 'vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kvs-token-3',
            type: 'product',
            icon: 'bulb',
            title: 'Product',
            dataType: 'product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kvs-token-4',
            type: 'cycle_decimals',
            icon: 'package',
            title: 'Cycle Decimals',
            dataType: 'cycle_decimals',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kvs-token-5',
            type: 'stream_cycle',
            icon: 'package',
            title: 'Stream Cycle',
            dataType: 'stream_cycle',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kvs-token-6',
            type: 'action',
            icon: 'pipeline',
            title: 'Action',
            dataType: 'action',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function FVSTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'fvs-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'db_id',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'fvs-token-2',
            type: 'vendor',
            icon: 'package',
            title: 'Vendor',
            dataType: 'vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-3',
            type: 'product',
            icon: 'bulb',
            title: 'Product',
            dataType: 'product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-4',
            type: 'cycle_decimals',
            icon: 'package',
            title: 'Cycle Decimals',
            dataType: 'cycle_decimals',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-5',
            type: 'action',
            icon: 'pipeline',
            title: 'Action',
            dataType: 'action',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function EPMTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'epm-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'db_id',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'epm-token-2',
            type: 'eol_product',
            icon: 'package',
            title: 'Eol Product',
            dataType: 'eol_product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'epm-token-3',
            type: 'apck_product',
            icon: 'package',
            title: 'Apck Product',
            dataType: 'apck_product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'epm-token-4',
            type: 'apck_vendor',
            icon: 'package',
            title: 'Apck Vendor',
            dataType: 'apck_vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'epm-token-5',
            type: 'fuzzy_version_stream_decimals',
            icon: 'package',
            title: 'Fuzzy Version Stream Decimals',
            dataType: 'fuzzy_version_stream_decimals',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'epm-token-6',
            type: 'action',
            icon: 'pipeline',
            title: 'Action',
            dataType: 'action',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function EOLTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'fvs-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'db_id',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'fvs-token-2',
            type: 'source_id',
            icon: 'package',
            title: 'Source ID',
            dataType: 'source_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-3',
            type: 'feed_id',
            icon: 'package',
            title: 'Feed ID',
            dataType: 'feed_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-4',
            type: 'release_date',
            icon: 'package',
            title: 'Release Date',
            dataType: 'release_date',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-5',
            type: 'latest',
            icon: 'package',
            title: 'Latest',
            dataType: 'latest',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-6',
            type: 'cycle',
            icon: 'package',
            title: 'Cycle',
            dataType: 'cycle',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-7',
            type: 'sortable_cycle',
            icon: 'package',
            title: 'Sortable Cycle',
            dataType: 'sortable_cycle',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-8',
            type: 'details',
            icon: 'package',
            title: 'Details',
            dataType: 'details',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-9',
            type: 'eol_product',
            icon: 'package',
            title: 'Eol Product',
            dataType: 'eol_product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-10',
            type: 'apck_product',
            icon: 'package',
            title: 'Apck Product',
            dataType: 'apck_product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-11',
            type: 'apck_vendor',
            icon: 'package',
            title: 'Apck Vendor',
            dataType: 'apck_vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-12',
            type: 'eol',
            icon: 'package',
            title: 'Eol',
            dataType: 'eol',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-13',
            type: 'eol_bool',
            icon: 'package',
            title: 'Eol Bool',
            dataType: 'eol_bool',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-14',
            type: 'support',
            icon: 'package',
            title: 'Support',
            dataType: 'support',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-15',
            type: 'support_bool',
            icon: 'package',
            title: 'Support Bool',
            dataType: 'support_bool',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-16',
            type: 'lts',
            icon: 'package',
            title: 'Lts',
            dataType: 'lts',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-17',
            type: 'lts_bool',
            icon: 'package',
            title: 'Lts Bool',
            dataType: 'lts_bool',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'fvs-token-18',
            type: 'action',
            icon: 'pipeline',
            title: 'Action',
            dataType: 'action',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function KEVTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'kev-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'db_id',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'kev-token-2',
            type: 'status',
            icon: 'details-block',
            title: 'Status',
            dataType: 'status',
            showFriendlyText: true,
            token: ImpactToken,
            options: FEED_STATUS_OPTIONS,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
            ],
        },
        {
            id: 'kev-token-3',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            dataType: 'description',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kev-token-4',
            type: 'name',
            icon: 'title',
            title: 'Name',
            dataType: 'name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kev-token-5',
            type: 'product',
            icon: 'bulb',
            title: 'Product',
            dataType: 'product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kev-token-6',
            type: 'vendor',
            icon: 'package',
            title: 'Vendor',
            dataType: 'vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kev-token-7',
            type: 'cve',
            icon: 'details-block',
            title: 'CVE',
            dataType: 'cve',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kev-token-8',
            type: 'action',
            icon: 'pipeline',
            title: 'Action',
            dataType: 'action',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'kev-token-9',
            type: 'due_date',
            icon: 'calendar',
            title: 'Due Date',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'kev-token-10',
            type: 'date_added',
            icon: 'calendar',
            title: 'Date Added',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'kev-token-11',
            type: 'first_known_exploitation_date',
            icon: 'calendar',
            title: 'First Known Exploitation Date',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
    ];
    return tokens;
}

export function VSTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'vs-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'db_id',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'vs-token-2',
            type: 'name',
            icon: 'title',
            title: 'Name',
            dataType: 'name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'vs-token-3',
            type: 'identifier',
            icon: 'api',
            title: 'Identifier',
            dataType: 'identifier',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function RawVulnerabilityTokenList(url, requestOptsFunc) {
    const tokens = VulnerabilityTokenList(url, requestOptsFunc);
    tokens.push({
        id: 'raw-vuln-token-1',
        type: 'source_id',
        icon: 'trigger-source',
        title: 'Source ID',
        operators: [
            {
                value: '=',
                description: 'is',
                default: 'true',
                allowEmpty: true,
            },
            { value: '!=', description: 'is not' },
            { value: '~', description: 'like' },
            { value: '~~', description: 'ilike' },
            { value: '^=', description: 'starts with' },
            { value: '!^=', description: 'does not start with' },
            { value: '∈', description: 'contains' },
            { value: '∉', description: 'does not contain' },
            { value: '=$', description: 'ends with' },
            { value: '!=$', description: 'does not end with' },
        ],
        showFriendlyText: true,
        token: ApckGlFilteredSearchToken,
    });
    return tokens;
}

export function CPEMetricTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'cpe-metric-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'id',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-metric-token-5',
            type: 'product',
            icon: 'bulb',
            title: 'Product',
            dataType: 'product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-metric-token-6',
            type: 'vendor',
            icon: 'package',
            title: 'Vendor',
            dataType: 'vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-metric-token-7',
            type: 'version',
            icon: 'details-block',
            title: 'Version',
            dataType: 'version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-metric-token-8',
            type: 'count_check_latest_version',
            icon: 'namespace',
            title: 'Count Check Latest Version',
            dataType: 'count_check_latest_version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-metric-token-8',
            type: 'count_vulns',
            icon: 'pipeline',
            title: 'Count Vulns',
            dataType: 'count_vulns',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-metric-token-9',
            type: 'date',
            icon: 'calendar',
            title: 'Date',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
    ];
    return tokens;
}

export function VulnMetricTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'vuln-metric-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'id',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'vuln-metric-token-2',
            type: 'vuln_id',
            icon: 'details-block',
            title: 'Vuln ID',
            dataType: 'vuln_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'vuln-metric-token-3',
            type: 'count',
            icon: 'namespace',
            title: 'Count',
            dataType: 'count',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'vuln-metric-token-4',
            type: 'date',
            icon: 'calendar',
            title: 'Date',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'vuln-metric-token-5',
            type: 'vuln.title',
            icon: 'title',
            title: 'Title',
            dataType: 'title',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'vuln-metric-token-5',
            type: 'vuln.workflow_quality',
            icon: 'chart',
            title: 'Workflow Quality',
            dataType: 'workflow_quality',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
    ];
    return tokens;
}

export function FullPatchTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'patch-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'id',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'patch-token-2',
            type: 'patch_id',
            icon: 'details-block',
            title: 'Patch ID',
            dataType: 'patch_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '∈',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-3',
            type: 'title',
            icon: 'title',
            title: 'Title',
            dataType: 'title',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-4',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            dataType: 'description',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-5',
            type: 'changes',
            icon: 'doc-changes',
            title: 'Changes',
            dataType: 'changes',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-6',
            type: 'issues',
            icon: 'issue-block',
            title: 'Issues',
            dataType: 'issues',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-7',
            type: 'patch_link',
            icon: 'link',
            title: 'Patch Link',
            dataType: 'patch_link',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'patch-token-8',
            type: 'release_date',
            icon: 'calendar',
            title: 'Release Date',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
    ];
    return tokens;
}

export function CPEPriorityTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'cpe-priority-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'id',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-priority-token-3',
            type: 'vendor',
            icon: 'building',
            title: 'Vendor',
            dataType: 'vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-priority-token-4',
            type: 'product',
            icon: 'cherry-pick-commit',
            title: 'Product',
            dataType: 'product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'cpe-priority-token-4',
            type: 'authenticated_detection',
            icon: 'notifications',
            title: 'Authenticated Detection',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS_NULL,
        },
        {
            id: 'cpe-priority-token-4',
            type: 'unauthenticated_detection',
            icon: 'notifications-off',
            title: 'Unauthenticated Detection',
            token: ImpactToken,
            options: BOOLEAN_OPTIONS_NULL,
        },
        {
            id: 'cpe-priority-token-10',
            type: 'customer_popularity',
            icon: 'media-broken',
            title: 'Customer Popularity',
            dataType: 'customer_popularity',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-priority-token-11',
            type: 'global_popularity',
            icon: 'bullhorn',
            title: 'Global Popularity',
            dataType: 'global_popularity',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-priority-token-12',
            type: 'intuition',
            icon: 'key',
            title: 'Intuition',
            dataType: 'intuition',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cpe-priority-token-13',
            type: 'priority',
            icon: 'hourglass',
            title: 'Priority',
            dataType: 'priority',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>=', description: 'greater than or equal to' },
                { value: '<=', description: 'smaller than or equal to' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
    ];
    return tokens;
}

export function TokenList(url, requestOptsFunc, showApckReportedCheck) {
    const tokens = [
        {
            id: 'token-11',
            type: 'title',
            icon: 'title',
            title: 'Title',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-18',
            type: 'cvss_v3_score',
            icon: 'star-o',
            title: 'CVSS V3 Score',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'is greater than' },
                { value: '<', description: 'is smaller than' },
                { value: '>=', description: 'is greater or equal to' },
                { value: '<=', description: 'is smaller or equal to' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-19',
            type: 'cvss_v2_score',
            icon: 'star-o',
            title: 'CVSS V2 Score',
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '>', description: 'is greater than' },
                { value: '<', description: 'is smaller than' },
                { value: '>=', description: 'is greater or equal to' },
                { value: '<=', description: 'is smaller or equal to' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'token-3',
            type: 'impact',
            icon: 'scale',
            title: 'Impact',
            token: ImpactToken,
            options: CUSTOMER_PROBABILITY_IMPACT_OPTIONS,
            unique: true,
        },
        {
            id: 'token-31',
            type: 'cves',
            icon: 'bug',
            title: 'CVE',
            multiSelect: false,
            displayKey: 'cve',
            key: 'db_id',
            url: `${url}/cves/`,
            paramGetter: (obj, forSelect) => {
                if (forSelect) {
                    return {};
                }
                return { search: String(obj.value.data) };
            },
            traditional: true,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                // { value: '~=', description: 'is one of' },
                // { value: '!~=', description: 'is not one of' },
            ],
            token: CVEToken,
        },
        {
            id: 'token-13',
            type: 'added',
            icon: 'calendar',
            title: 'Added',
            showFriendlyText: true,
            operators: [
                {
                    value: '=',
                    description: 'on',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'not on' },
                { value: '>=', description: 'after' },
                { value: '<=', description: 'before' },
            ],
            inputType: 'date',
            token: DateTimeToken,
        },
        {
            id: 'token-10',
            type: 'vendor',
            icon: 'building',
            title: 'Vendor',
            multiSelect: false,
            displayKey: 'vendor',
            key: 'vendor',
            url: `${url}/vulnerabilities/vuln-vendors/`,
            paramGetter: (obj, forSelect) => {
                if (forSelect) {
                    return {};
                }
                return { search: String(obj.value.data) };
            },
            traditional: true,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: false,
                },
            ],
            token: MultiLabelToken,
            cacheResults: true,
            hideNoneSuggestion: true,
            unique: true,
            defaultOptions: [
                {
                    "vendor": "wordpress"
                }, 
                {
                    "vendor": "microsoft"
                }, 
                {
                    "vendor": "google"
                }, 
                {
                    "vendor": "oracle"
                }, 
                {
                    "vendor": "debian"
                }, 
                {
                    "vendor": "apple"
                }, 
                {
                    "vendor": "ibm"
                }, 
                {
                    "vendor": "linux"
                }, 
                {
                    "vendor": "adobe"
                }, 
                {
                    "vendor": "redhat"
                }, 
                {
                    "vendor": "fedoraproject"
                }, 
                {
                    "vendor": "cisco"
                }, 
                {
                    "vendor": "canonical"
                }, 
                {
                    "vendor": "opensuse"
                }, 
                {
                    "vendor": "mozilla"
                },
            ],
        },
        {
        id: 'token-142',
        type: 'has_kev',
        icon: 'earth',
        title: 'Has Known Exploitation',
        token: ImpactToken,
        unique: true,
        operators: [{ value: '=', description: 'is', default: 'true' }],
        options: [
            { icon: 'check-circle-filled', value: 'true', title: 'Yes' },
        ],
    }
    ];
    if (showApckReportedCheck) {
        tokens.push({
            id: 'token-141',
            type: 'apck_reported',
            icon: 'bullhorn',
            title: 'Supported by Scanner',
            token: ImpactToken,
            unique: true,
            operators: [{ value: '=', description: 'is', default: 'true' }],
            options: [
                { icon: 'check-circle-filled', value: 'true', title: 'Yes' },
                // { icon: 'check-circle-dashed', value: 'false', title: 'All' },
            ],
        });
    }
    return tokens.sort((a, b) => (a.title > b.title ? 1 : -1));
}

export function CipherSuiteTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'cipher-suite-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'id',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'cipher-suite-token-2',
            type: 'title',
            icon: 'title',
            title: 'Title',
            data: 'title',
            dataType: 'title',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-3',
            type: 'gnutls_name',
            icon: 'title',
            title: 'Gnutls Name',
            data: 'gnutls_name',
            dataType: 'gnutls_name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-4',
            type: 'openssl_name',
            icon: 'title',
            title: 'Openssl Name',
            data: 'openssl_name',
            dataType: 'openssl_name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-5',
            type: 'hex_byte_1',
            icon: 'text-description',
            title: 'Hex Byte 1',
            data: 'hex_byte_1',
            dataType: 'hex_byte_1',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-6',
            type: 'hex_byte_2',
            icon: 'text-description',
            title: 'Hex Byte 2',
            data: 'hex_byte_2',
            dataType: 'hex_byte_2',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-7',
            type: 'protocol_version',
            icon: 'list-numbered',
            title: 'Protocol Version',
            data: 'protocol_version',
            dataType: 'protocol_version',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-8',
            type: 'kex_algorithm',
            icon: 'api',
            title: 'Kex Algorithm',
            data: 'kex_algorithm',
            dataType: 'kex_algorithm',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-9',
            type: 'auth_algorithm',
            icon: 'api',
            title: 'Auth Algorithm',
            data: 'auth_algorithm',
            dataType: 'auth_algorithm',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-10',
            type: 'enc_algorithm',
            icon: 'api',
            title: 'Enc Algorithm',
            data: 'enc_algorithm',
            dataType: 'enc_algorithm',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-11',
            type: 'hash_algorithm',
            icon: 'api',
            title: 'Hash Algorithm',
            data: 'hash_algorithm',
            dataType: 'hash_algorithm',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'cipher-suite-token-12',
            type: 'security',
            icon: 'lock',
            title: 'Security',
            token: ApckGlFilteredSearchToken,
            options: SECURITY_OPTIONS,
        },
    ];
    return tokens;
}

export function VulnImportFilterTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'vuln-import-filter-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'id',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'vuln-import-filter-token-2',
            type: 'feed_name',
            icon: 'trigger-source',
            title: 'Feed Name',
            token: LabelToken,
            displayKey: 'name',
            key: 'name',
            url: `${url}/feeds/`,
            requestOptsFunc,
            paramGetter: (obj) => ({ all: true, search: String(obj.value.data) }),
            cacheResults: true,
        },
        {
            id: 'vuln-import-filter-token-3',
            type: 'conditions',
            icon: 'filter',
            title: 'Conditions',
            operators: [
                { value: '∈', description: 'contains' },
                { value: '∈S', description: 'contains (case sensitive)' },
                { value: '∉', description: 'does not contain' },
            ],
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
        },
        {
            id: 'vuln-import-filter-token-4',
            type: 'name',
            icon: 'title',
            title: 'Name',
            dataType: 'name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'vuln-import-filter-token-5',
            type: 'filter_type',
            icon: 'formula',
            title: 'Filter Type',
            unique: true,
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            options: [
                { icon: 'trash', value: 'Junk', title: 'Junk' },
                { icon: 'check', value: 'Auto Approve', title: 'Auto Approve' },
            ],
        },
    ];
    return tokens;
}

export function SecurityAlertTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'security-alert-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'id',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'security-alert-token-2',
            type: 'title',
            icon: 'title',
            title: 'Title',
            data: 'title',
            dataType: 'title',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
        {
            id: 'security-alert-token-3',
            type: 'severity',
            icon: 'severity-unknown',
            title: 'Severity',
            token: ApckGlFilteredSearchToken,
            options: SEVERITY_OPTIONS,
        },
        {
            id: 'security-alert-token-4',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            data: 'description',
            dataType: 'description',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
            ],
        },
    ];
    return tokens;
}

export function LogoTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'logo-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'db_id',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'logo-token-3',
            type: 'note',
            icon: 'text-description',
            title: 'Note',
            dataType: 'note',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'logo-token-4',
            type: 'name',
            icon: 'title',
            title: 'Name',
            dataType: 'name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'logo-token-5',
            type: 'update_str',
            icon: 'title',
            title: 'Update',
            dataType: 'update_str',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'logo-token-6',
            type: 'display_info',
            icon: 'bulb',
            title: 'Display Name',
            dataType: 'display_info',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function DisplayInfoTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'displayinfo-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'db_id',
            dataType: 'db_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
                { value: '>', description: 'greater than' },
                { value: '<', description: 'smaller than' },
            ],
        },
        {
            id: 'displayinfo-token-3',
            type: 'vendor',
            icon: 'text-description',
            title: 'Vendor',
            dataType: 'vendor',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'displayinfo-token-4',
            type: 'product',
            icon: 'title',
            title: 'Product',
            dataType: 'product',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'displayinfo-token-5',
            type: 'update_str',
            icon: 'title',
            title: 'Update',
            dataType: 'update_str',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'displayinfo-token-6',
            type: 'display_name',
            icon: 'bulb',
            title: 'Display Name',
            dataType: 'display_name',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}

export function APIClientTokens(url, requestOptsFunc) {
    const tokens = [
        {
            id: 'api-client-token-1',
            type: 'id',
            icon: 'commit',
            title: 'ID',
            data: 'id',
            dataType: 'id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                { value: '=', description: 'is', default: 'true' },
                { value: '!=', description: 'is not one of' },
            ],
        },
        {
            id: 'api-client-token-2',
            type: 'client_id',
            icon: 'text-description',
            title: 'Client ID',
            dataType: 'client_id',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'api-client-token-3',
            type: 'scopes',
            icon: 'text-description',
            title: 'Scopes',
            dataType: 'scopes',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
        {
            id: 'api-client-token-4',
            type: 'description',
            icon: 'text-description',
            title: 'Description',
            dataType: 'description',
            showFriendlyText: true,
            token: ApckGlFilteredSearchToken,
            requestOptsFunc,
            operators: [
                {
                    value: '=',
                    description: 'is',
                    default: 'true',
                    allowEmpty: true,
                },
                { value: '!=', description: 'is not' },
                { value: '~', description: 'like' },
                { value: '~~', description: 'ilike' },
                { value: '^=', description: 'starts with' },
                { value: '!^=', description: 'does not start with' },
                { value: '∈', description: 'contains' },
                { value: '∉', description: 'does not contain' },
                { value: '=$', description: 'ends with' },
                { value: '!=$', description: 'does not end with' },
            ],
        },
    ];
    return tokens;
}
